import React from 'react';

export default function Privacy() {
  return (
    <div style={{ width: '100%', minHeight: '100vh' }}>
      <iframe
        title="ProjectLoop Privacy Policy"
        src="https://app.termly.io/policy-viewer/policy.html?policyUUID=d0cfcfc7-b8a5-48cc-be56-5342933d1d2f"
        style={{ width: '100%', minHeight: '100vh', border: 'none' }}
      />
    </div>
  );
}
